import { createLazyComponent } from '@muse-web/router'

import { CommentListLoading, CommentListSection } from '../components/comment-list'

const CommentListFallback = () => (
    <CommentListSection>
        <CommentListLoading />
    </CommentListSection>
)

export const AsyncCommentListContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'audio-comments' */ './CommentListContainer'),
    'CommentListContainer',
    { keepServerMarkup: true, fallback: CommentListFallback },
)
